import WPTabs from "./WPTabs";

export default WPTabs;